import { Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import DisclosureGuidelinesIncomeStructure from '@Router/NatureOfBusiness/Components/DisclosureGuidelines/DisclosureGuidelinesIncomeStructure';
import IncomeStructureProvider from './IncomeStructureProvider';
import IncomeStructureIntroduction, {
  INCOME_STRUCTURE_INTRODUCTION_ID,
} from './IncomeStructureIntroduction';
import IncomeStructureRemark, {
  INCOME_STRUCTURE_REMARK_ID,
} from './IncomeStructureRemark';
import ProductIncome from './ProductIncome';
import ExportIncome from './ExportIncome';
import OtherIncome from './OtherIncome';
import IncomeStructureCompletedCheckbox from './IncomeStructureCompletedCheckbox';

const IncomeStructure = () => {
  return (
    <Box bgcolor={'white'}>
      <Box p={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1} alignItems={'center'}>
            <Typography fontWeight={800}>โครงสร้างรายได้</Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <IncomeStructureIntroduction />
              <IncomeStructureRemark />
            </Flex>
          </Flex>
          <DisclosureGuidelinesIncomeStructure />
        </Flex>
        <Box id={INCOME_STRUCTURE_INTRODUCTION_ID} />
        <Box id={INCOME_STRUCTURE_REMARK_ID} />
        <IncomeStructureProvider>
          <ProductIncome />
          <ExportIncome />
          <OtherIncome />
        </IncomeStructureProvider>
      </Box>
      <IncomeStructureCompletedCheckbox />
    </Box>
  );
};

export default IncomeStructure;
